import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';

const SectionWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  padding-top: .5rem;
  width: 100%;
  height: 100%;
`;

function Section({ children, ...props }, ref) {
  return (
    <SectionWrapper>
      <Grid
        container
        direction="column"
        justify="flex-start"
        alignItems="stretch"
        xs={12}
        md={12}
        xl={6}
      >
        {children}
      </Grid>
    </SectionWrapper>
  );
}

export default Section;
